module.exports = __webpack_public_path__ + "static/media/img_plan_pro_plus.b3a9a09c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img_plan_pro_plus.svg
// module id = 387
// module chunks = 0